<div
  class="zoom-row"
  [tp]="hasDetail() ? detailTooltip : tooltip()"
  [tpPlacement]="'top'"
>
  @if (content(); as entry) {
    <app-slot-rarity-outline [entry]="entry" [spritesheet]="spritesheet()">
      @if (owned() >= quantity()) {
        <span badge-br>{{ quantity() }}</span>
      } @else {
        <span badge-br-unmet>{{ quantity() }}</span>
      }
    </app-slot-rarity-outline>
  } @else {
    <app-icon-unknown />
  }
</div>

<ng-template #detailTooltip>
  <app-detail-item-preview [display]="previewDisplay()">
    <div class="type-meta mt-2">
      Owned: {{ owned() | number }} / {{ quantity() | number }}
    </div>

    @if (materialId(); as itemId) {
      <app-detail-material-sources [itemId]="itemId" />
    }
  </app-detail-item-preview>
</ng-template>
